import { ChevronLeftIcon } from "@/components/icons/chevronLeft.icon";

import type { GetNavigationQueryResult } from "@/sanity.types";

import { SiteHeaderShopByMenu } from "./siteHeaderShopByMenu.component";

export const SiteHeaderMobileMenuTitle = ({
  selectedMenu,
  setSelectedMenu,
  shopByMenu,
}: SiteHeaderMobileMenuTitleProps) => {
  if (!selectedMenu) {
    return <SiteHeaderShopByMenu menu={shopByMenu} />;
  }

  return (
    <nav data-testid="site-header-mobile-menu-title">
      <button
        type="button"
        className="flex items-center gap-2 font-normal"
        data-testid="site-header-mobile-menu-back"
        onClick={() => setSelectedMenu("")}>
        <span className="text-greyscale-strength" aria-hidden>
          <ChevronLeftIcon width={18} height={18} />
        </span>
        All
      </button>
    </nav>
  );
};

export type SiteHeaderMobileMenuTitleProps = {
  selectedMenu?: string;
  setSelectedMenu: (menu: string) => void;
  shopByMenu?: GetNavigationQueryResult;
};
